/* 18+ confirmation above Check out (17 Oct 2026). Markup and styles: snippets/age-confirm.liquid,
   rendered in the side cart and on the cart page. Kept apart from the cart code in theme.js and
   main-cart.liquid on purpose: it only reads the Check out controls and never redraws the cart.

   - Check out carries aria-disabled and points at the hint until the box is ticked. A click on it
     then goes to the box instead of checkout.
   - The side cart (data-age-confirm-error-state, Cart Drawer 4b, 17 Oct 2026) never disables Check
     out. An unticked press shows the error state (is-prompt: 3px royal box, royal label), marks the
     box invalid with the hint as its description, and moves focus to it. Ticking clears it.
   - Express pay (data-age-confirm-gate) stays inert under a clear lock button until the tick is
     saved to the cart, so Apple Pay or Google Pay can never start a checkout without it. A tap on
     the lock shows the same error state.
   - The tick is saved as the cart attribute "Age confirmation" through /cart/update.js, so it lands
     on the order and stays ticked on reload. Unticking clears it. Saves run one at a time, and
     Check out waits for the last one before it goes. If that save fails (offline, a Shopify error),
     Check out still goes: the buyer has ticked, and the cart page box also posts with its form.
   - The side cart and the cart page boxes stay in step, and the side cart re-reads the cart when it
     opens, because a cached page can print an old state. */
(function () {
  var KEY = 'Age confirmation';
  var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-age-confirm]'));
  if (!blocks.length) return;

  var VALUE = blocks[0].getAttribute('data-age-confirm-value');
  var box = function (b) { return b.querySelector('[data-age-confirm-check]'); };
  var hint = function (b) { return b.querySelector('[data-age-confirm-hint]'); };
  var soft = function (b) { return b.hasAttribute('data-age-confirm-error-state'); };
  var saved = blocks.some(function (b) { return box(b).checked; }) ? VALUE : '';
  var chain = Promise.resolve();
  var pending = 0;
  var edits = 0;
  var going = false;

  function controlsOf(b) {
    var sel = b.getAttribute('data-age-confirm-target');
    return sel && b.parentElement ? Array.prototype.slice.call(b.parentElement.querySelectorAll(sel)) : [];
  }

  function gatesOf(b) {
    var sel = b.getAttribute('data-age-confirm-gate');
    return sel && b.parentElement ? Array.prototype.slice.call(b.parentElement.querySelectorAll(sel)) : [];
  }

  // Express pay opens only once the cart holds the tick, not while the save is still on its way.
  function gate() {
    blocks.forEach(function (b) {
      var open = box(b).checked && saved === VALUE && !pending;
      gatesOf(b).forEach(function (g) {
        var inner = g.querySelector('[data-age-gate-inner]');
        var lock = g.querySelector('[data-age-gate-lock]');
        if (inner) {
          inner.inert = !open;
          if (open) inner.removeAttribute('inert');
          else inner.setAttribute('inert', '');
        }
        if (lock) lock.hidden = open;
        g.classList.toggle('is-locked', !open);
      });
    });
  }

  function described(el, id, on) {
    var ids = (el.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (x) { return x && x !== id; });
    if (on) ids.push(id);
    if (ids.length) el.setAttribute('aria-describedby', ids.join(' '));
    else el.removeAttribute('aria-describedby');
  }

  function paint(on) {
    blocks.forEach(function (b) {
      var h = hint(b);
      var s = soft(b);
      box(b).checked = on;
      if (h) h.hidden = on;
      if (on) {
        b.classList.remove('is-prompt');
        box(b).removeAttribute('aria-invalid');
        if (h) described(box(b), h.id, false);
      }
      controlsOf(b).forEach(function (el) {
        if (on || s) el.removeAttribute('aria-disabled');
        else el.setAttribute('aria-disabled', 'true');
        if (h) described(el, h.id, !on && !s);
      });
    });
    gate();
  }

  function save(value) {
    pending++;
    var body = { attributes: {} };
    body.attributes[KEY] = value;
    chain = chain
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('cart update ' + r.status);
        return r.json();
      })
      .then(function (cart) { saved = (cart.attributes && cart.attributes[KEY]) || ''; })
      .catch(function (err) { console.error('GRADA: age confirmation save error', err); })
      .then(function () { pending--; gate(); });
    gate();
    return chain;
  }

  function sync() {
    if (pending) return;
    var at = edits;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (pending || edits !== at) return;
        saved = (cart.attributes && cart.attributes[KEY]) || '';
        paint(saved === VALUE);
      })
      .catch(function () {});
  }

  function prompt(b) {
    b.classList.remove('is-prompt');
    void b.offsetWidth;
    b.classList.add('is-prompt');
    if (soft(b)) {
      var h = hint(b);
      box(b).setAttribute('aria-invalid', 'true');
      if (h) { h.hidden = false; described(box(b), h.id, true); }
    }
    box(b).focus();
  }

  function go(el) {
    if (el.tagName === 'A') { window.location.href = el.href; return; }
    going = true;
    try {
      if (el.form && el.form.requestSubmit) el.form.requestSubmit(el);
      else el.click();
    } finally { going = false; }
  }

  function blockFor(target) {
    var hit = null;
    blocks.some(function (b) {
      var sel = b.getAttribute('data-age-confirm-target');
      var el = sel && target && target.closest ? target.closest(sel) : null;
      if (el && b.parentElement && b.parentElement.contains(el)) { hit = { block: b, el: el }; return true; }
      return false;
    });
    return hit;
  }

  function onCheckout(e) {
    if (going) return;
    var hit = blockFor(e.target);
    if (!hit) return;
    if (!box(hit.block).checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (e.type !== 'auxclick') prompt(hit.block);
      return;
    }
    if (e.type === 'auxclick') return;
    // Ticked: go now if the cart already holds it, otherwise save it first, then go.
    if (!pending && saved === VALUE) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    save(VALUE).then(function () { go(hit.el); });
  }

  blocks.forEach(function (b) {
    box(b).addEventListener('change', function (e) {
      var on = e.target.checked;
      edits++;
      paint(on);
      save(on ? VALUE : '');
    });
  });

  // The lock over express pay: unticked shows the error; ticked but still saving waits for the save.
  document.addEventListener('click', function (e) {
    var lock = e.target && e.target.closest ? e.target.closest('[data-age-gate-lock]') : null;
    if (!lock) return;
    e.preventDefault();
    blocks.some(function (b) {
      if (!gatesOf(b).some(function (g) { return g.contains(lock); })) return false;
      if (!box(b).checked) prompt(b);
      else if (saved !== VALUE && !pending) save(VALUE);
      return true;
    });
  });

  document.addEventListener('click', onCheckout, true);
  document.addEventListener('auxclick', onCheckout, true);
  // A submit that skips the click (requestSubmit from other code) is held the same way.
  document.addEventListener('submit', function (e) {
    if (going || !e.submitter) return;
    var hit = blockFor(e.submitter);
    if (hit && !box(hit.block).checked) { e.preventDefault(); prompt(hit.block); }
  }, true);

  paint(saved === VALUE);

  // The cart page prints the box in its own section: read the cart once so a cached page is right.
  var drawer = document.getElementById('grada-cart-drawer');
  var onPage = blocks.some(function (b) { return !drawer || !drawer.contains(b); });
  if (onPage) sync();
  if (drawer && window.MutationObserver) {
    new MutationObserver(function () {
      if (drawer.getAttribute('aria-hidden') === 'false') sync();
    }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) sync();
  });
})();
